import { z } from 'zod';

// Stable error codes returned by the API. Clients switch on these, so never rename one;
// domain codes (e.g. `event_full`) are added by the tasks that introduce them.
export const ERROR_CODES = [
	'bad_request',
	'validation_error',
	'unauthorized',
	'forbidden',
	'not_found',
	'method_not_allowed',
	'conflict',
	'payload_too_large',
	'unsupported_media_type',
	'rate_limited',
	'internal_error',
	// Auth (T-105)
	'init_data_invalid',
	'init_data_expired',
	'account_banned',
	'account_deleted',
	// Create event (T-302)
	'profile_incomplete',
	'active_event_limit',
	'daily_event_limit',
	'outside_city',
	'category_unavailable',
	// Edit / cancel (T-304)
	'seats_below_accepted',
	'event_not_editable',
	// Apply (T-401)
	'own_event',
	'applications_closed',
	'event_started',
	'event_full',
	'already_applied',
	'application_final',
	'reapply_limit',
	'pending_limit',
	// Organizer decisions (T-403)
	'application_not_pending',
	'not_participant',
	'no_show_window',
	// Chat (T-601)
	'chat_closed',
	// Quick statuses outside 2 h before the start … the end (T-904)
	'status_not_now',
	// Profile (T-701)
	'uploads_unavailable',
	// Moderation (T-802): a reported user's writes are paused pending review (PRIVACY §4)
	'writes_paused',
	// Reviews (T-901)
	'reviews_closed',
	'not_reviewable',
	// Admin panel (T-1102a/e): one code for every refused sign-in, so it reveals nothing
	'admin_sign_in_refused',
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export const errorCodeSchema = z.enum(ERROR_CODES);

/** Body of every non-2xx API response: `{ "error": { "code", "message", "details?" } }`. */
export const errorResponseSchema = z.object({
	error: z.object({
		code: errorCodeSchema,
		message: z.string(),
		details: z.unknown().optional(),
	}),
});

export type ErrorResponse = z.infer<typeof errorResponseSchema>;
